import { h } from 'preact';
import { Select, Option } from '@cube/blocks';
import * as constants from './constants';
import { Text } from 'preact-i18n';

const INTL_NS = 'annual-quarterly-selector';

export default function AnnualQuarterlySelector({ onChange, value, ...props }) {
	return  (
		<Select {...props} onChange={onChange} value={value} iconPosition="right">
			<Option title={<Text id={`${INTL_NS}.${constants.ANNUAL}`} />} value={constants.ANNUAL} />
			<Option title={<Text id={`${INTL_NS}.${constants.QUARTERLY}`} />} value={constants.QUARTERLY} />
		</Select>
	);
}
